"use client";
import React from "react";

export const Skeleton = ({ className = "" }: { className?: string }) => (
  <div className={`animate-pulse bg-slate-200 dark:bg-slate-700 rounded ${className}`} />
);

export const CardSkeleton = () => (
  <div className="animate-pulse rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm">
    <div className="h-48 bg-slate-200 rounded-2xl mb-4" />
    <div className="h-6 bg-slate-200 rounded w-3/4 mb-3" />
    <div className="h-4 bg-slate-200 rounded w-full mb-2" />
    <div className="h-4 bg-slate-200 rounded w-5/6" />
  </div>
);

export const DealerCardSkeleton = () => (
  <div className="animate-pulse rounded-xl border bg-white p-4 shadow-sm mb-4">
    <div className="h-5 bg-slate-200 rounded w-2/3 mb-3" />
    <div className="h-4 bg-slate-200 rounded w-full mb-2" />
    <div className="h-4 bg-slate-200 rounded w-4/5" />
  </div>
);

export const GallerySkeleton = () => (
  <div className="grid gap-6 xl:grid-cols-2">
    {[1,2,3,4].map(i=> <CardSkeleton key={i}/>)}
  </div>
);

export const MapSkeleton = () => (
  <div className="animate-pulse h-[75%] w-full bg-slate-200 rounded-2xl flex items-center justify-center">
    <span className="text-slate-400 text-sm">Loading map...</span>
  </div>
);
